import { NeuroFaixaEtariaEnum, StatusAvaliadoEnum } from 'graphql/types.generated'
import { emptyArrayOf } from 'util/array'

import { AvaliacaoDesenvolvimentoModel } from '../model'

export const faixaEtariaAnterior = (
  marco: Partial<Record<NeuroFaixaEtariaEnum, ReadonlyArray<AvaliacaoDesenvolvimentoModel>>>
): ReadonlyArray<AvaliacaoDesenvolvimentoModel> =>
  (Object.values(marco) ?? emptyArrayOf<AvaliacaoDesenvolvimentoModel[]>())
    .toReversed()
    .slice(1)
    .find((avaliacoes: AvaliacaoDesenvolvimentoModel[]) =>
      avaliacoes.some((item) => item.statusButton !== StatusAvaliadoEnum.NAO_AVALIADO)
    )
